<template>
  <div id="app">
    <main>
      <h1>
        <img src="./assets/img/logo.png" alt="mozo sustainable park" ref="logo">
      </h1>
      <div class="scroll">
        <img src="./assets/img/scroll.png" alt="">
      </div>
      <section class="message">
        <div class="wrapper">
          <div class="inner">
            <p>
              m o z o  w o n d e r  c i t y の中の、小さな公園。ここはモゾサステナブルパークという持続可能な社会を目指したショッピングを体験する小さなショップです。
            </p>
            <p>
              当たり前にあるいまの暮らし。その裏側では、たくさんの社会問題があります。mozoが考えるこれからの生活はもっと地球や自然に寄り添った生活や暮らしを提案したい。
            </p>
            <p>
              そんな思いを込めて、小さなショップをつくりました。みなさまと未来の生活が、より健康的で心地良くなるために。
            </p>
            <p>
              ようこそ、m o z o S U S T A I N A B L E  P A R K へ。
            </p>
          </div>
        </div>
      </section>
      <div class="overlay">
        <section class="importance">
          <div class="bg"></div>
          <div class="wrapper">
            <div class="inner">
              <h2>
                持続可能な社会を<br>
                目指すことの、大切さ
              </h2>
              <p>
                例えば、私たちの着ている服はどのような資源を使いどのような人が、どのような環境で作っているのか。ゴミ箱の向こう側は、どのようになっているのか。
              </p>
              <p>
                必要以上に多くのものを作ればそれだけ廃棄のリスクは高まります。自然環境や生産環境を省みなければどこかで破綻するリスクがあります。
              </p>
              <p>
                消費者の満足を徹底的に目指した社会からものを作る生産者にとっても資源の恵みを与える自然にとっても満足になる社会が、持続可能な社会といえるのです。
              </p>
              <p>
                それは、社会全体が健康的になることなのです。
              </p>
            </div>
          </div>
        </section>
        <section class="popup">
          <h2>
            <img src="./assets/img/pop_up_h2.png" alt="">
          </h2>
          <div class="slide">
            <slick
            ref="slick"
            :options="slickOptions"
            v-if="items.length"
            >
              <div v-for="(item, i) in items" :key="i" class="item">
                <div class="img">
                  <img :src="`./popup/img/popup_${i+1}.jpg`">
                </div>
                <div class="text">
                  <h3 v-text="item.title"></h3>
                  <p class="description" v-html="item.description"></p>
                  <p class="period">
                    開催期間：
                    <span class="start">
                      {{ moment(item.start, 'MM月DD日') }}
                    </span>
                    ～
                    <span class="end">
                      {{ moment(item.end, 'MM月DD日') }}
                    </span>
                  </p>
                  <p class="notice">
                    ※イベントは予告なく中止・変更する場合がございます
                  </p>
                  <p class="ended" v-if="isEnd(item.end)">
                    こちらのイベントは終了しました
                  </p>
                  <!-- <a :href="item.link">
                    <img src="./assets/img/pop_up_mozoplus.png" alt=""
                    class="pc mozoplus">
                    <img src="./assets/img/pop_up_mozoplus_sp.png" alt=""
                    class="sp mozoplus">
                  </a> -->
                </div>
              </div>
            </slick>
          </div>
        </section>
        <section class="curation">
          <div class="wrapper">
            <div class="inner">
              <h2>
                <img src="./assets/img/curation_h2.png" class="pc" alt="">
                <img src="./assets/img/curation_h2_sp.png" class="sp" alt="">
              </h2>
              <p class="lead">
                サステナブルパークには、<br>
                未体験の驚きや気づきを与えてくれる、<br>
                環境的に設計された厳選アイテムなどを揃えています。<br>
                ぜひ現地で実際にご覧ください！
              </p>
              <p class="banner"><a href="https://plus.mozo-wondercity.com/all/svc/product/Search/?fromform=1&page=1&shop_id=104&sort=2" rel="noopener noreferrer" target="_blank" onclick="ga(send', 'event', '【sustainable-park】', 'click', 'mozoplusバナー');"><img src="./assets/img/banner_mozoplus.png" alt=""></a></p>
              <!-- <ul>
                <li v-for="(item, i) in items2" :key="i"
                @click="modalOverlay=i"
                >
                  <div class="img">
                    <img :src="`./popup/img/curation_${i+1}.jpg`">
                  </div>
                  <div class="text">
                    <h3>
                      {{item.title}}
                    </h3>
                    <p class="price">
                      税込：{{item.price}}円
                    </p>
                  </div>
                </li>
              </ul> -->
            </div>
          </div>
        </section>
      </div>
    </main>
    <transition name="fadeIn">
      <div class="modalOverlay"
      v-if="modalOverlay!=null" @click="modalOverlay=null"
      ></div>
    </transition>
    <div class="modal" v-if="modalOverlay!=null">
      <div class="content">
        <div class="img">
          <img :src="`./popup/img/curation_${modalOverlay+1}.jpg`">
        </div>
        <div class="text">
          <div class="close" @click="modalOverlay=null">
            <img src="./assets/img/modal_close.png" alt="">
          </div>
          <div class="brand">
            {{items2[modalOverlay].brand}}
          </div>
          <h3>
            {{items2[modalOverlay].title}}
          </h3>
          <p class="description">
            {{items2[modalOverlay].description}}
          </p>
          <p class="price">
            税込：{{items2[modalOverlay].price}}円
          </p>
          <a :href="items2[modalOverlay].link">
            <img src="./assets/img/modal_mozoplus.png" class="pc" alt="">
            <img src="./assets/img/modal_mozoplus_sp.png" class="sp" alt="">
          </a>
        </div>
      </div>
    </div>
    <footer ref="footer">
      <div class="banner">
        <div class="wrapper">
          <div class="inner">
            <a href="/" onclick="ga('send', 'event', '【sustainable-park】', 'click', 'アプリ');">
              <img src="./assets/img/banner.jpg" class="pc" alt="">
              <img src="./assets/img/banner_sp.jpg" class="sp" alt="">
            </a>
          </div>
        </div>
      </div>
      <div class="main">
        <div class="wrapper">
          <div class="inner">
            <div class="tel">
            サステナブルパーク専用お問合せ先　<br class="sp"><a href="tel:08057643268">080-5764-3268</a>（10：00～18：00）
            </div>
            <div class="logo">
              <a href="/">
                <img src="./assets/img/footer_logo.png" alt="">
              </a>
            </div>
            <ul class="links">
              <li>
                <a href="https://www.facebook.com/Mozo-wondercity-164641164108183/" rel="noopener noreferrer" target="_blank">
                  <img src="./assets/img/fb.png" alt="facebook">
                </a>
              </li>
              <li>
                <a href="https://line.me/R/ti/p/%40znr2267g" rel="noopener noreferrer" target="_blank">
                  <img src="./assets/img/line.png" alt="line">
                </a>
              </li>
              <li>
                <a href="http://twitter.com/share?url=https://www.mozo-wondercity.com/lp/sustainable-park/&text=mozo サステナブルパーク" rel="noopener noreferrer" target="_blank">
                  <img src="./assets/img/tw.png" alt="twitter">
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="copyright">
        <div class="wrapper">
          <div class="inner">
            <p>
              &copy; mozo wonder city all rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
    <transition name="fadeIn">
      <div class="pageTop" v-if="isPinned">
        <a href="#app"
        v-smooth-scroll="{ duration: 1000}"
        >
          <img src="./assets/img/pagetop.png" alt="">
        </a>
      </div>
    </transition>
    <transition name="fadeIn">
      <div class="checkIn" @click="checkInModal=true" v-if="showCheck">
        <img src="./assets/img/checkin.png" alt="">
      </div>
    </transition>
    <transition name="scaleIn">
      <div class="checkInModal" v-if="checkInModal">
        <div class="heading">
          <div class="close" @click="checkInModal=false">
            <img src="./assets/img/checkin_close.jpg" alt="">
          </div>
          <h2>
            mozoポイントがもらえる<br>
            チェックインキャンペーン実施中！
          </h2>
          <p class="lead">
            mozo sustinable parkでは参加者の皆様にポイントプレゼントを実施しています。<br>
            <br>
            mozoアプリを使ってチェックインカウンターでチェックインするともれなくmozoポイントがもらえます。
          </p>
          <div class="banner">
            <img src="./assets/img/checkin_banner.png" alt="">
          </div>
          <div class="notice">
            <h3>
              ご注意
            </h3>
            <p>
              mozo sustainable parkのチェックインカウンター以外で押してもポイントは付与されないのでご了承ください。
            </p>
          </div>
        </div>
        <div class="policy">
          <h2>
            行動データ取得ポリシー
          </h2>
          <p class="policyText" ref="policy" @scroll="policyScroll">
            データの取得・利用及び匿名加工情報の作成・提供に関するお知らせ<br>
            <br>
            ◆mozoワンダーシティで皆様がより楽しく・心地よく過ごしていただけるよう、データの分析を実施しています。<br>
            <br>
            mozoワンダーシティ（以下「mozo」といいます。）を保有する日本都市ファンド投資法人の資産運用会社である三菱商事・ユービーエス・リアルティ株式会社（以下「当社」といいます。）では、サステナブルをテーマにmozoにて様々な企画を行っておりますが、お客様にとってより魅力的なイベント・サービス・商品につなげるため、オフライン（mozo内のPOPUP店舗）とオンライン（mozoアプリ・mozoPLUS）で取得したお客様のデータの分析を2021年11月27日より実施しています。<br>
            <br>
            上記の目的のため、当社はmozoアプリにチェックイン機能を設定し、mozoアプリＩＤと同ＩＤに紐づく属性データ（性別、年齢、住所及びmozoアプリ上の行動データ）を、mozoウエストコート内特設会場（以下「特設会場」といいます。）内での行動データと紐づけ、統合することによって、匿名加工情報（特定の個人を識別することができないように個人情報を加工して得られる個人に関する情報であって、当該個人情報を復元できないようにしたものをいいます。）を作成し、これらを業務委託先へ提供し分析いたします。<br>
            <br>
            ◆　特設会場にて取得する情報及び利用目的<br>
            	取得する情報<br>
            ・特設会場内のカメラで記録したお客様の顔を含む全身画像（ただし、即座に削除し、いかなる記録媒体にも保存いたしません）<br>
            ・特設会場内での行動データ（チェックイン及び店内行動履歴）<br>
            	利用目的<br>
            個人が識別できない状態での顧客行動の分析（市場ニーズの分析、商品・サービス開発のための分析等を含みますが、これらに限りません。）<br>
            <br>
            ◆匿名加工情報に含まれる個人に関する情報<br>
            ・性別<br>
            ・年齢<br>
            ・住所（市区町村）<br>
            ・mozoアプリ上の行動データ（各種サービスの利用状況及び取引履歴）<br>
            ・特設会場内での行動データ（チェックイン及び店内行動履歴）<br>
            <br>
            ◆匿名加工情報の提供方法<br>
            ・パスワードで保護された電子ファイルの電子メールによる送信<br>
            ・高度なセキュリティで保護されたサーバーへのアクセス<br>
            <br>
            ◆本件に関するお問い合わせ先<br>
            株式会社アド・ウォーク（サポート業務委託先）<br>
            <br>
            電話　080-5764-3268（10：00〜18：00）
          </p>
          <a :class="(policyRead&&!checked)?'active':''"
          @click="checked=true"
          onclick="fanship.events.emit('event_checkin');"
          >
            <img src="./assets/img/checkin_go.png" alt="" v-if="!checked">
            <span v-else>完了</span>
          </a>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger)
import Slick from 'vue-slick';
import moment from 'moment';

export default {
  name: 'App',
  components: { Slick },
  data() {
    return {
      items: [],
      items2: [],
      modalOverlay: null,
      isPinned: false,
      logoLoad: false,
      checkInModal: false,
      scrollY: 0,
      vw: 0,
      policyRead: false,
      checked: false,
      slickOptions: {
        initialSlide: 0,
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        centerMode: true,
        centerPadding: 0,
        prevArrow: '<div class="arrow prev"></div>',
        nextArrow: '<div class="arrow next"></div>',
        responsive: [{
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          }
        }],
      },
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    document. documentElement.scrollTop = 0
    gsap.fromTo(
      this.$refs.logo,
      {
        opacity: 0,
        y: 10,
      },
      {
        opacity: 1,
        y: 0,
        duration: .5,
      },
      1,
    )
    gsap.fromTo(
      '.scroll',
      {
        opacity: 0,
        y: 10,
      },
      {
        opacity: 1,
        y: 0,
        duration: .5,
      },
      1.5,
    )
    setTimeout(()=>{
      this.logoLoad = true;
      gsap.set(this.$refs.logo, {
        opacity: 1,
      });
      document.body.classList.add('loaded')
      gsap.to(this.$refs.logo, {
        scrollTrigger: {
          trigger: '.message .inner',
          toggleActions: 'play complete reverse complete',
          start: 'top bottom',
          end: 'top center',
          scrub: true,
        },
        duration: .5,
        opacity: .2,
      })
    }, 1000)
    let messages = document.querySelectorAll('.message p')
    messages.forEach((el,i)=>{
      var leave = i!=(messages.length-1) ? 'reverse' : 'none'
      gsap.to(el, {
        scrollTrigger: {
          trigger: el,
          toggleActions: `play ${leave} play reverse`,
          start: 'cenetr center',
          end: '+='+el.clientHeight,
        },
        duration: .1,
        opacity: 1,
      })
    })
    gsap.to('.message', {
      scrollTrigger: {
        trigger: '.importance',
        start: 'top bottom',
        end: 'footer',
        toggleActions: 'play reverse play reverse',
        scrub: true,
      },
      ease: 'linear',
      y: document.documentElement.clientHeight,
    })
    gsap.to('.importance', {
      scrollTrigger: {
        trigger: '.importance',
        endTrigger: 'footer',
        start: 'top center',
        end: 'bottom top',
        toggleActions: 'play none play none',
        toggleClass: "active",
      },
    })
  },
  created(){
    this.getData()
  },
  computed: {
    showCheck(){
      if(!this.logoLoad) return false
      const $element = this.$refs.footer;
      const rect = $element.getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      return (this.scrollY + window.innerHeight < rect.top + scrollTop)
    }
  },
  methods: {
    handleScroll(){
      const $element = document.querySelector(".importance");
      const rect = $element.getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.isPinned = rect.top + scrollTop < window.scrollY
      this.scrollY = window.scrollY
    },
    async getData(){
      const res = await Promise.all([
        this.$http.get('./popup/data.json'),
        this.$http.get('./popup/data2.json')
      ])
      console.log(res);
      this.items = res[0].data
      this.items2 = res[1].data
      var startDays = []
      var found = false;
      this.items.forEach((item,i)=>{
        var start = moment(item.start)
        if (!moment(item.start).isValid()) return
        startDays.push(start)
        var isBetween = this.isBetween(item.start, item.end)
        if (!isBetween) return
        found = true;
        this.slickOptions.initialSlide = i;
        console.log(i)
      })
      if(!found) {
        this.slickOptions.initialSlide = this.nextDateIndex(startDays);
      }
    },
    moment(date, format) {
      return moment(date).format(format)
    },
    isEnd(date){
      const now = Date()
      return (moment(date).add(1, 'days')).isBefore(now)
    },
    isBetween(start, end){
      const now = Date()
      return moment(now).isBetween(start, moment(end).endOf('day'), null, '[]')
    },
    nextDateIndex(dates){
      var next = [
          ...dates
        ].map(function(s){
          return moment(s, "MM/DD/YYYY HH:mm");
        })
        .sort(function(m){
          return m.valueOf();
        })
        .findIndex(function(m){return m.isAfter();});
      return next
    },
    policyScroll(e){
      var element = e.target
      const clientHeight = element.getBoundingClientRect().height;
      const scrollHeight = element.scrollHeight;
      const scrollTop = element.scrollTop;
      if(scrollHeight - (clientHeight + scrollTop) <= 0 ) this.policyRead = true
    },
    check(){
      this.checked = true
    }
  },
}
</script>

<style lang="scss">
@import './assets/css/reset.css';
@import './assets/css/slick.css';
$bp: 768px;
@mixin PC {
  @media (min-width:$bp){
    @content;
  }
}
@mixin SP {
  @media (max-width:$bp){
    @content;
  }
}
html {
  font-size: 10px;
  @media screen and (max-width: 1920px) {
    font-size: 0.520833333vw;
  }
  @media screen and (max-width: 768px) {
    font-size: 1.33333333vw;
  }
}
.pc {
  display: block !important;
  @include SP {
    display: none !important;
  }
}
.sp {
  display: none !important;
  @include SP {
    display: block !important;
  }
}
body {
  font-size: 1.6rem;
  font-family: "Noto Sans JP";
}
img {
  image-rendering: -webkit-optimize-contrast;
}
.wrapper {
  width: 100%;
  max-width: 192rem;
  margin: 0 auto;
}
.inner {
  width: 100%;
  max-width: 120rem;
  margin: 0 auto;
  @include SP {
    padding: 0 6rem;
  }
}
h1 {
  img {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: 43.4rem;
    z-index: 98;
    @include SP {
      width: 56rem;
    }
  }
}
.scroll {
  width: 1.4rem;
  height: 25.8rem;
  position: fixed;
  top: calc(100vh - 25.8rem);
  right: 4.4rem;
}
.message {
  position: relative;
  font-family: fot-tsukuardgothic-std, sans-serif;
  font-weight: bold;
  font-style: normal;
  padding-top: calc(100vh + 22rem);
  padding-bottom: calc(50vh - 10rem);
  p {
    position: relative;
    z-index: 99;
    font-size: 2.4rem;
    line-height: 2;
    letter-spacing: .5em;
    opacity: .2;
    padding-bottom: 10rem;
    @include SP {
      font-size: 3.4rem;
      letter-spacing: .2em;
    }
  }
}

.overlay {
  position: relative;
  z-index: 99;
  background: #fff;
}

.importance {
  position: relative;
  padding: 14rem 0;
  color: #fff;
  overflow: hidden;
  .bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url('./assets/img/importance_bg.jpg') center top / cover no-repeat;
    @keyframes zoom {
      0% {
        transform: scale(1);
      }
      0% {
        transform: scale(1.1);
      }
    }
    animation: zoom;
    animation-duration: 30s;
    animation-fill-mode: both;
    animation-iteration-count: infinite;
    animation-direction: alternate;
  }
  .wrapper {
    position: relative;
  }
  h2, p {
    opacity: 0;
    transition: .4s;
  }
  h2 {
    font-size: 4rem;
    line-height: 7rem;
    font-weight: bold;
    letter-spacing: .25em;
    margin-bottom: 10rem;
    @include SP {
      font-size: 5.4rem;
      letter-spacing: .1em;
    }
  }
  p {
    font-family: fot-tsukuardgothic-std, sans-serif;
    font-size: 2.4rem;
    line-height: 2;
    letter-spacing: .5em;
    @include SP {
      font-size: 3.4rem;
      letter-spacing: .2em;
    }
    &:nth-of-type(1) {
      margin-bottom: 8rem;
    }
    &:nth-of-type(2) {
      margin-bottom: 12rem;
    }
    &:nth-of-type(3) {
      margin-bottom: 8rem;
    }
  }
  &.active {
    h2, p {
      opacity: 1;
      transition: .8s;
    }
    p {
      &:nth-of-type(1) {
        transition-delay: .8s;
      }
      &:nth-of-type(2) {
        transition-delay: 1.6s;
      }
      &:nth-of-type(3) {
        transition-delay: 2.4s;
      }
      &:nth-of-type(4) {
        transition-delay: 3.2s;
      }
    }
  }
}
.checkIn {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 37rem;
  z-index: 998;
  transition: 1s;
  transition-delay: 1s;
  @include PC {
    display: none;
  }
}
.checkInModal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba($color: #fff, $alpha: 1.0);
  z-index: 999;
  overflow: scroll;
  .close {
    width: 10rem;
    margin: 0 0 4.2rem auto;
  }
  .heading {
    padding: 0 6rem 7rem;
    background: url('./assets/img/checkin_bg.jpg') center top / cover no-repeat;
    h2 {
      color: #ffea01;
      font-weight: bold;
      font-size: 3.8rem;
      text-align: center;
      margin-bottom: 4.2rem;
    }
    .lead {
      font-size: 3.2rem;
      color: #fff;
      margin-bottom: 5.5rem;
    }
    .banner {
      margin-bottom: 6rem;
    }
    .notice {
      color: #e10000;
      background: #fff1f1;
      border: .4rem solid #e10000;
      padding: 3rem 2.8rem;
      border-radius: 2.6rem;
      h3 {
        font-size: 3.6rem;
        text-align: center;
        font-weight: bold;
        margin-bottom: 2.4rem;
      }
      p {
        font-size: 2.8rem;
      }
    }
  }
  .policy {
    padding: 7rem 6rem 12rem;
    h2 {
      font-size: 3.6rem;
      font-weight: bold;
      margin-bottom: 3rem;
    }
    p {
      height: 44rem;
      overflow: scroll;
      border: .4rem solid #c9c9c9;
      border-radius: 2.6rem;
      padding: 3rem 2.8rem;
      font-size: 2.6rem;
      line-height: 4.4rem;
      margin-bottom: 5rem;
    }
    a {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 13rem;
      border-radius: 2.6rem;
      background: #bdbdbd;
      padding: 0 3rem;
      pointer-events: none;
      img {
        width: 26rem;
      }
      span {
        font-size: 4rem;
        font-weight: bold;
        color: #fff;
      }
      &.active {
        background: #7eaf00;
        pointer-events: all;
      }
      &::after {
        content: "";
        position: absolute;
        top: 0;
        bottom: 0;
        right: 3rem;
        margin: auto;
        width: 4.3rem;
        height: 4.4rem;
        display: block;
        background: url('./assets/img/checkin_arrow.png') center center / contain no-repeat ;
      }
    }
  }
}
.popup {
  padding: 10rem 11rem 4rem;
  @include SP {
    padding: 7.8rem 0 0;
  }
  h2 {
    text-align: center;
    margin-bottom: 7.6rem;
    img {
      width: 52rem;
    }
  }
  .slide {
    position: relative;
    .arrow {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
      width: 6.6rem;
      height: 6.6rem;
      background: url('./assets/img/pop_up_arrow.png') center center / contain no-repeat;
      cursor: pointer;
      z-index: 99;
      @include SP {
        top: 50rem;
        margin: 0;
        width: 10rem;
        height: 10rem;
        left: auto;
        right: auto;
      }
      &.prev {
        transform: translateX(-60rem);
        @include SP {
          transform: none;
          left: 0;
        }
      }
      &.next {
        transform: translateX(60rem) scale(-1);
        @include SP {
          right: 0;
          transform: scale(-1);
        }
      }
    }
  }
  .slick-track {
    display: flex !important;
  }
  .slick-slide {
    height: inherit !important;
    &>div {
      height: 100%;
      &>div {
        display: flex !important;
        height: 100%;
      }
    }
  }
  .item {
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    flex-direction: column;
    width: 54.7rem;
    padding: 0 3.6rem;
    @include SP {
      width: 100%;
      padding: 0;
    }
    .img {
      margin-bottom: 2.8rem;
      flex-shrink: 0;
    }
    .text {
      display: flex;
      justify-content: flex-start;
      align-items: stretch;
      flex-direction: column;
      height: 100%;
      @include SP {
        padding: 10rem 6rem;
      }
      h3 {
        font-size: 3rem;
        line-height: 1.4;
        font-weight: bold;
        white-space: pre-line;
        margin-bottom: 2.8rem;
        @include SP {
          font-size: 5rem;
          line-height: 7rem;
          margin-bottom: 4rem;
        }
      }
      .description {
        font-size: 2rem;
        line-height: 2.2;
        white-space: pre-line;
        margin-bottom: 1em;
        @include SP {
          font-size: 3.2rem;
        }
      }
      .period {
        margin-top: auto;
        font-size: 2.8rem;
        font-weight: bold;
        text-align: center;
        @include SP {
          font-size: 3.8rem;
        }
      }
      .notice {
        margin-top: 1em;
        text-align: center;
        font-size: 1.8rem;
        @include SP {
          font-size: 2.4rem;
        }
      }
      .ended {
        font-size: 2.4rem;
        color: #a6a6a6;
        font-weight: bold;
        margin: .5em 0 1.5em;
        text-align: center;
        @include SP {
          font-size: 3.2rem;
        }
      }
      .mozoplus {
        cursor: pointer;
      }
    }
  }
}
.curation {
  padding: 10rem 0;
  background: url('./assets/img/curation_bg.jpg') center center / cover no-repeat;
  h2 {
    text-align: center;
    margin-bottom: 7.2rem;
    img {
      width: 82rem;
      margin: 0 auto;
      @include SP {
        margin: 0 auto;
        width: 52rem;
      }
    }
  }
  .lead {
    font-size: 2.4rem;
    color: #fff;
    line-height: 2;
    text-align: center;
  }
  .banner {
    margin: 2rem auto 0;
    max-width: 88rem;
  }
  ul {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    flex-wrap: wrap;
    li {
      display: flex;
      justify-content: flex-start;
      align-items: stretch;
      flex-direction: column;
      width: 37rem;
      color: #fff;
      margin-bottom: 5rem;
      cursor: pointer;
      @include SP {
        width: 30.6rem;
      }
      .img {
        margin-bottom: 4.8rem;
        border-radius: 2.6rem;
        flex-shrink: 0;
        overflow: hidden;
        @include SP {
          margin-bottom: 3rem;
        }
      }
      .text {
        display: flex;
        justify-content: flex-start;
        align-items: stretch;
        flex-direction: column;
        height: 100%;
        h3 {
          font-size: 2.2rem;
          margin-bottom: 1em;
          @include SP {
            font-size: 2.8rem;
          }
        }
        .price {
          text-align: right;
          font-size: 1.6rem;
          margin-top: auto;
          @include SP {
            font-size: 2.4rem;
          }
        }
      }
    }
  }
}
.modalOverlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba($color: #000000, $alpha: .6);
  z-index: 999;
}
.modal {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  background: #fff;
  width: 82.6rem;
  height: 48rem;
  padding: 3.8rem 4rem;
  border-radius: 2.3rem;
  z-index: 999;
  @include SP {
    width: calc(100% - 4rem);
    height: calc(100% - 4rem);
    margin: 2rem;
    padding: 0 6rem;
  }
  .content {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    @include SP {
      display: flex;
      justify-content: flex-start;
      align-items: stretch;
      flex-direction: column;
      padding: 8rem 0;
      width: 100%;
      height: 100%;
      overflow: scroll;
    }
    .img {
      width: 40rem;
      height: 100%;
      flex-shrink: 0;
      @include SP {
        width: 100%;
        height: 60rem;
        margin-bottom: 5rem;
      }
      img {
        object-fit: cover;
      }
    }
    .text {
      position: relative;
      display: flex;
      justify-content: flex-start;
      align-items: stretch;
      flex-direction: column;
      padding-left: 3rem;
      .brand {
        font-weight: bold;
        font-size: 1.6rem;
        @include SP {
          font-size: 3rem;
        }
      }
      h3 {
        font-weight: bold;
        font-size: 2.4rem;
        line-height: 2;
        @include SP {
          font-size: 5rem;
          line-height: 1.2;
          margin-bottom: 4rem;
        }
      }
      .description {
        font-size: 1.6rem;
        line-height: 1.6;
        @include SP {
          font-size: 3.2rem;
        }
      }
      .price {
        margin: auto 0 1em;
        font-size: 2rem;
        font-weight: bold;
        text-align: right;
        @include SP {
          margin-top: 1em;
          font-size: 3.4rem;
        }
      }
      a {
        display: block;
      }
      .close {
        position: absolute;
        top: 0;
        right: 0;
        width: 3.4rem;
        height: 3.4rem;
        cursor: pointer;
        @include SP {
          position: fixed;
          top: 5rem;
          right: 5rem;
        }
      }
    }
  }
}
footer {
  position: relative;
  z-index: 99;
  background: #fff;
  .banner {
    padding: 6rem 0 10rem;
    text-align: center;
    .inner {
      @include SP {
        padding: 0;
      }
    }
    img {
      width: 88rem;
      margin: 0 auto;
    }
  }
  .main {
    height: 28rem;
    background: #dadada;
    padding-bottom: 5rem;
    @include SP {
      height: 45rem;
      padding: 5rem;
    }
    .wrapper {
      height: 100%;
    }
    .inner {
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
    }
    .tel {
      width: 100%;
      text-align: center;
      font-size: 2rem;
      @include SP {
        font-size: 3rem;
        padding-bottom: 4rem;
      }
      a {
        text-decoration: underline;
      }
    }
    .logo {
      width: 14.3rem;
      @include SP {
        width: 19rem;
      }
    }
    .links {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      li {
        width: 6.4rem;
        @include SP {
          width: 7.2rem;
        }
        &+li{
          margin-left: 2.8rem;
          @include SP {
            margin-left: 3.6rem;
          }
        }
      }
    }
  }
  .copyright {
    background: #333333;
    text-align: center;
    color: #fff;
    .inner {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 4.8rem;
      @include SP {
        height: 6rem;
      }
    }
    p {
      font-size: 1.8rem;
      @include SP {
        font-size: 2.6rem;
      }
    }
  }
}

.pageTop {
  position: fixed;
  bottom: 4rem;
  right: 5rem;
  z-index: 99;
  width: 8.7rem;
  height: 8.4rem;
  cursor: pointer;
}

.fadeIn-enter-active, .fadeIn-leave-active{
  transition: opacity .4s
}

.fadeIn-enter, .fadeIn-leave-to{
  opacity: 0;
}

.scaleIn-enter-active, .scaleIn-leave-active{
  transition: .2s
}

.scaleIn-enter, .scaleIn-leave-to{
  transform: scale(1.1);
  opacity: 0;
}
</style>
